import {buffer, debounceTime, filter, fromEvent, map, Observable, Subject} from 'rxjs';

export module RxUtils {

  /**
   * The dblclick event is never fired on mobile, this emulates it with RxJs.
   */
  export function doubleClick(target: EventTarget, debounceTimeInMs = 250): Observable<MouseEvent> {
    const clickObservable = fromEvent<MouseEvent>(target, 'click');
    return clickObservable.pipe(
      buffer(clickObservable.pipe(debounceTime(debounceTimeInMs))),
      filter((list: Array<MouseEvent>) => list.length === 2),
      map((list: Array<MouseEvent>) => list[list.length - 1]),
    );
  }

  /**
   * Create an observable emitting on every animation frames.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
   * @return Observable emitting the timestamp of the frame, in milliseconds
   */
  export function animationFrame(): Observable<number> {
    const subject = new Subject<number>();
    const callback = (timestamp: number): void => {
      subject.next(timestamp);
      if (subject.observed) {
        requestAnimationFrame(callback);
      } else {
        subject.complete();
      }
    };
    requestAnimationFrame(callback);
    return subject.asObservable();
  }

}
